import 'angular';
import * as _ from 'lodash-es';
import Features from '../feature-manager/Features';
import AppConstants from '../gorillaboy/AppConstants';
import { RootScope } from '../types/angular-types';
import {TasksControllerScope, GetTasksResponse, Task, Action} from '../types/TaskTypes';
import TasksService from './TasksService';
import {TasksMessageManager} from './TasksMessageManager';
import './contact_admin/ContactAdminTaskCtrl';
import './transferResources/TransferResourcesTaskCtrl';
import './content_partial.html';
import './title_bar.html';
import './new_task_dialog.html';
import './access_request/accessRequestModalController';
import './access_request/accessRequestModal.html';
import './task_details/taskDetailsModalController';
import './task_details/taskDetailsModal.html';
import {ITaskDefinitionHelper} from "./TaskDefinitionHelper";
import './TaskDefinitionHelper';
import './empty_task_list/emptyTaskListDirective';
import {TaskSelectionManager} from './taskSelectionManager';
import {ISelectedItem} from '../types/selectionManager';

function TasksController($rootScope: RootScope, $scope: TasksControllerScope, $log: ng.ILogService, TasksService: TasksService,
         View: string, userInfo: any, FeatureManagerService: any,
         $translate: ng.translate.ITranslateService, $q: ng.IQService, $sce: ng.ISCEService,
         FileService: any, MessageManager: any, DocumentService: any, SignalProvider: any,
         $uibModal: any, DateTimeService: any, TasksMessageManager: TasksMessageManager,
         TaskDefinitionHelper: ITaskDefinitionHelper) {

    $log.info("TasksController init");
    $scope.getReadableDate = DateTimeService.getHumanReadableDate;
    $scope.taskDefHelper = TaskDefinitionHelper;

    //Eventual consistency takes time. For better UX hide those tasks on which user has taken actions.
    $scope.tasksOnWhichUserTookActions = [];

    $scope.taskTypesGroupA = [{
        Name : $translate.instant('TASKS.TASK_TYPE_NAMES.' + AppConstants.TASK_TYPES.REQUEST_ACCESS),
        TaskDefinitionId: AppConstants.TASKDEF_IDS.REQUEST_ACCESS
    }, {
        Name : $translate.instant('TASKS.TASK_TYPE_NAMES.' + AppConstants.TASK_TYPES.TRANSFER_RESOURCE_OWNERSHIP),
        TaskDefinitionId: AppConstants.TASKDEF_IDS.TRANSFER_RESOURCE_OWNERSHIP
    }];

    $scope.taskTypesGroupB = [];
    if (!$scope.isFeatureEnabled(Features.UI.DISABLE_CONTACT_ADMIN_TASKS)) {
        $scope.taskTypesGroupB.push({
            Name : $translate.instant('TASKS.TASK_TYPE_NAMES.' + AppConstants.TASK_TYPES.NOTIFY_ADMIN_TO_DO),
            TaskDefinitionId: AppConstants.TASKDEF_IDS.NOTIFY_ADMIN_TO_DO
        });
    }

    $scope.taskSelectionManager = new TaskSelectionManager($rootScope);

    // SECTION: Layout code
    $scope.layout = {
        partialContent: './tasks/content_partial.html',
        partialTitleBar: './tasks/title_bar.html',
        view: View,
        hasRightSidebar: false,
        showRightSidebar: false,
        showUploadPane: false,
        httpStatus: null
    };

    function updateActionOptions() {
        $scope.actions = [];
        if ($scope.taskSelectionManager.getTotalSelectedItemCount() >= 1) {
            $scope.actions.push({
                ID: "DELETE",
                TextMapping: $translate.instant('TASKS.LIST_VIEW.ACTIONS.DELETE')
            });
        }
    }

    $scope.getResolverName = (task: Task) => {
        if (task.TaskDefinitionId === AppConstants.TASKDEF_IDS.NOTIFY_ADMIN_TO_DO) {
            return $translate.instant('TASKS.LIST_VIEW.RESOLVER_NAMES.ADMIN');
        }
        return task.Resolver ? $scope.getFullName(task.Resolver) : '';
    };

    $scope.onlyExclusiveSelection = () => {
        return $scope.layout.view === AppConstants.Tasks.Views.AssignedTasks;
    }

    if (View === AppConstants.Tasks.Views.AssignedTasks) {
        document.title = $translate.instant('TASKS.LIST_VIEW.ASSIGNED_TASKS_WINDOW_TITLE') + ' - ' + AppConstants.APP_NAME;
    } else {
        document.title = $translate.instant('TASKS.LIST_VIEW.MY_TASKS_WINDOW_TITLE') + ' - ' + AppConstants.APP_NAME;
    }

    $scope.isMyTasksView = function() {
       return View === AppConstants.Tasks.Views.MyTasks;
    };

    $scope.isAssignedTasksView = function() {
       return View === AppConstants.Tasks.Views.AssignedTasks;
    };

    $scope.isArchiveView = function() {
        return View === AppConstants.Tasks.Views.ArchivedTasks;
    };

    $scope.getEmptyMessage = function() {
        if (View === AppConstants.Tasks.Views.AssignedTasks) {
            return $translate.instant('TASKS.LIST_VIEW.NO_ASSIGNED_TASKS_TO_DISPLAY');
        }
        return $translate.instant('TASKS.LIST_VIEW.NO_TASKS_TO_DISPLAY');
    };

    $scope.createTransferOwnershipTask = function() {
        const newTaskModal = $uibModal.open({
            templateUrl: "./tasks/transferResources/transfer_resources_task.html",
            controller: 'TransferResourcesTaskCtrl',
            size: 'md'
        });

        postProcessModalOpening(newTaskModal);
    };

    $scope.createContactAdminTask = function() {
        const newTaskModal = $uibModal.open({
            templateUrl: "./tasks/contact_admin/contact_admin_task.html",
            controller: 'ContactAdminTaskCtrl',
            windowClass: 'contact-admin-task-dialog',
            size: 'lg'
        });
        postProcessModalOpening(newTaskModal);
    };

    function postProcessModalOpening(newTaskModal) {
        newTaskModal.result.then(function(response) {
            reloadView();
        });

        $scope.$on("$destroy", function() {
            if (newTaskModal) {
                newTaskModal.close();
            }
        });
    }

    $scope.createTask = function(taskDefinitionId: string) {
        switch (taskDefinitionId) {
            case AppConstants.TASKDEF_IDS.REQUEST_ACCESS:
                showAccessRequestModal();
                return;

            case AppConstants.TASKDEF_IDS.TRANSFER_RESOURCE_OWNERSHIP:
                $scope.createTransferOwnershipTask();
                return;

            case AppConstants.TASKDEF_IDS.NOTIFY_ADMIN_TO_DO:
                $scope.createContactAdminTask();
                return;

            default:
                return;
        }
    };

    $scope.executeTaskAction = function(task: Task, actionId: string) {
        //Internal actions include things like redirections to other views
        if (TaskDefinitionHelper.isInternalAction(task, actionId)) {
            TaskDefinitionHelper.takeInternalAction(task, actionId)
            return;
        }

        if (TaskDefinitionHelper.isDenyAction(task.TaskDefinitionId, actionId)) {
            $scope.showTaskDetailsModal(task, true);
            return;
        }
        TasksService.takeAction(task.Id, actionId)
        .then(() => {
            $scope.tasksOnWhichUserTookActions.push(task.Id);
            reloadView();
            TasksMessageManager.showSuccessMessageForTaskAction(task, actionId);
        }, () => {
            TasksMessageManager.showErrorMessageForTaskAction(task, actionId);
        });
    };

    function deleteSelectedTasks() {
        //delete one or more tasks
        let taskIdsToDelete : string[] = $scope.taskSelectionManager.getSelectedItems().map((selectedItem: ISelectedItem) => {
            return selectedItem.item.Id;
        })

        let promises = taskIdsToDelete.map(id => {
            return TasksService.deleteTask(id)
                .then(() => {
                    return "SUCCESS";
                }, () => {
                    return "FAILURE";
                });
        });
        if (promises.length) {
            $q.all(promises)
                .then((responses : string[]) => {
                    const allRequestsSuccessful = responses.every(deleteResponse => deleteResponse === "SUCCESS");
                    if (!allRequestsSuccessful) {
                        MessageManager.addErrorMessage($translate.instant('TASKS.LIST_VIEW.ERROR_MESSAGES.BULK_TASK_DELETION_FAILED'));
                    }
                    responses.forEach((deleteResponse, idx) => {
                        if (deleteResponse === "SUCCESS") {
                            //Eventual consistency takes time. For better UX hide those tasks on which user has taken actions.
                            $scope.tasksOnWhichUserTookActions.push(taskIdsToDelete[idx]);
                        }
                    });
                    reloadView();
                });
        }
    }

    $scope.takeBulkAction = function(action: Action) {
        $log.info("Attempting to take action " + action.ID);
        
        if ($scope.taskSelectionManager.getTotalSelectedItemCount() <= 0) {
            //Nothing to do, just return
            return;
        }

        if (action.ID == "DELETE") {
            deleteSelectedTasks();
        }
    };

    $scope.$on(SignalProvider.ContentLoading.LoadMore, function($event, data) {
        $scope.loadMore();
        $event.stopPropagation();
    });

    /**
     * Removes the Tasks on which user has taken action on.
     * @param tasks
     */
    function filterTasksOnWhichUserTookActions(tasks: Task[]) {
        return tasks.filter(task =>
            $scope.tasksOnWhichUserTookActions.indexOf(task.Id) === -1); //ignore the tasks acted upon
    }

    /**
     * This is the aggregator function that delegates to other single-principle functions
     * @param tasks
     */
    function processNewTasks(tasks: Task[]) {
        //Eventual consistency takes time. For better UX hide those tasks on which user has taken actions.
        return filterTasksOnWhichUserTookActions(tasks);
    }

    $scope.getTaskComments = (task: Task) => {
        if (!task.MetadataParsed || !task.MetadataParsed[AppConstants.Tasks.MetadataFields.ADDITIONAL_COMMENT]) {
            return task.Description;
        }
        var comments = JSON.parse(task.MetadataParsed[AppConstants.Tasks.MetadataFields.ADDITIONAL_COMMENT]);
        if (comments.length <= 0) {
            return task.Description;
        }
        return comments[comments.length - 1].message;
    };

    var contentLoadingPromise = null;
    $scope.loadMore = function() {
        if (!contentLoadingPromise || $scope.paginationMarker) {
            $log.info("Attempting to load more tasks");
            //signal that we're loading more
            $scope.$broadcast(SignalProvider.ContentLoading.Start);

            let resp: ng.IPromise<GetTasksResponse> = null;
            if (View === AppConstants.Tasks.Views.AssignedTasks) {
                resp = TasksService.getAssignedTasks($scope.paginationMarker);
            } else if (View === AppConstants.Tasks.Views.ArchivedTasks) {
                resp = TasksService.getArchivedTasks($scope.paginationMarker);
            } else {
                resp = TasksService.getTasks(null, null, null, $scope.paginationMarker);
            }
            resp.then((promiseResp) => {
                $scope.taskList = $scope.taskList.concat(processNewTasks(promiseResp.Tasks));
                $scope.taskSelectionManager.setTaskList($scope.taskList);
                $scope.paginationMarker = promiseResp.Marker;
            }, (promiseResp: GetTasksResponse) => {
                $scope.metricServiceInstance.newCounterMetric("TasksService.LoadMoreError");
                MessageManager.addErrorMessage($translate.instant('TASKS.LIST_VIEW.ERROR_MESSAGES.LOAD_MORE_FAILED'));

                //reset the pagination marker so that the load more doesn't trigger recursively
                $scope.paginationMarker = null;
                return $q.reject(promiseResp);
            });

            resp.finally(() => {
                //signal that we're done loading more
                $scope.$broadcast(SignalProvider.ContentLoading.Done);
            });
        }
    };

    function reloadView() {
        $log.info("TasksController.reloadView() called");
        $scope.actions = [];
        $scope.layout.httpStatus = null;
        $scope.taskList = [];
        $scope.paginationMarker = null;
        $scope.globalForm = {
            allTasksSelected: false
        };
        let resp: ng.IPromise<GetTasksResponse> = null;
        if (View === AppConstants.Tasks.Views.AssignedTasks) {
            resp = TasksService.getAssignedTasks($scope.paginationMarker);
        } else if (View === AppConstants.Tasks.Views.ArchivedTasks) {
            resp = TasksService.getArchivedTasks($scope.paginationMarker);
        } else {
            resp = TasksService.getTasks(null, null, null, $scope.paginationMarker);
        }
        resp.then((promiseResp) => {
            $log.info("TasksService.getAssignedTasks or getArchivedTasks or getTasks promise is resolved");

            $scope.taskList = processNewTasks(promiseResp.Tasks);
            $scope.taskSelectionManager.initTaskList($scope.taskList);


            $scope.paginationMarker = promiseResp.Marker;
            $scope.layout.httpStatus = promiseResp.httpStatus;
            $scope.metricServiceInstance.newCounterMetric("TasksView.LoadSuccess");
        }, (promiseResp: GetTasksResponse) => {
            $log.info("TasksService.getAssignedTasks or getArchivedTasks or getTasks promise is rejected");
            $scope.layout.httpStatus = promiseResp.httpStatus;
            $scope.metricServiceInstance.newCounterMetric("TasksService.LoadError");
            return $q.reject(promiseResp);
        });
    }

    $scope.showTaskDetailsModal = function(task: Task, showCommentTextarea : boolean) {
        var taskDetailsModal = $uibModal.open({
            templateUrl: './tasks/task_details/taskDetailsModal.html',
            controller: 'taskDetailsModalCtrl',
            size: 'md',
            resolve: {
                task: () => task,
                View : () => View,
                showCommentTextarea : () => !!showCommentTextarea
            }
        });
        taskDetailsModal.result.then(()=> {
            //this means the Task is acted upon, which means it should be taken out of view
            $scope.tasksOnWhichUserTookActions.push(task.Id);
        });
        postProcessModalOpening(taskDetailsModal);
    }

    $scope.areAllTasksSelected = function() {
        return $scope.taskList.length === $scope.taskSelectionManager.getTotalSelectedItemCount();
    };

    $scope.toggleTaskSelection = function(task: Task) {
        if (task === undefined) {
            // If no task is passed in, toggle all
            if ($scope.areAllTasksSelected()) {
                $scope.taskSelectionManager.clearSelected();
            } else {
                $scope.taskSelectionManager.selectAll();
            }
        } else {
            if ($scope.taskSelectionManager.isSelected(AppConstants.ResourceTypes.TASK, task.Id)) {
                $scope.taskSelectionManager.unselect(AppConstants.ResourceTypes.TASK, task.Id);
            } else {
                if ($scope.onlyExclusiveSelection()) {
                    $scope.taskSelectionManager.markAsSelectedExclusively(AppConstants.ResourceTypes.TASK, task.Id);
                } else {
                    $scope.taskSelectionManager.markAsSelected(AppConstants.ResourceTypes.TASK, task.Id);
                }
            }
        }
        
    };

    $scope.isTaskDetailButtonActive = function() {
        return $scope.taskSelectionManager.getTotalSelectedItemCount() === 1;
    };

    function showAccessRequestModal() {
        var accessRequestModal = $uibModal.open({
            templateUrl: './tasks/access_request/accessRequestModal.html',
            controller: 'accessRequestModalCtrl',
            size: 'md',
            resolve: {
                TargetResourceId: function() {
                    return null;
                }
            }
        });
        postProcessModalOpening(accessRequestModal);
    }

    reloadView();

    $scope.$on(SignalProvider.Selection.TaskSelected , onSelectionUpdated);
    $scope.$on(SignalProvider.Selection.TaskUnselected , onSelectionUpdated);
    $scope.$on(SignalProvider.Selection.TaskSelectedAll, onSelectionUpdated);
    $scope.$on(SignalProvider.Selection.TaskUnselectedAll, onSelectionUpdated);
    $scope.$on(SignalProvider.Selection.SelectionUpdated, updateActionOptions);

    function onSelectionUpdated(event) {
        $rootScope.$broadcast(SignalProvider.Selection.SelectionUpdated);
    }
}

TasksController.$inject = ['$rootScope',
    '$scope',
    '$log',
    'TasksService',
    'View',
    'userInfo',
    'FeatureManagerService',
    '$translate',
    '$q',
    '$sce',
    'FileService',
    'MessageManager',
    'DocumentService',
    'SignalProvider',
    '$uibModal',
    'DateTimeService',
    'TasksMessageManager',
    'TaskDefinitionHelper'];

angular.module('GorillaBoy.Tasks')
.controller('TasksController', TasksController);
